(function () {
  const modal = document.getElementById("cm-flashdeal-modal");
  if (!modal) return;

  const grid = modal.querySelector("[data-cm-grid]");
  const closeEls = modal.querySelectorAll("[data-cm-close]");
  const goCartBtn = modal.querySelector("[data-cm-go-cart]");

  const collectionHandle = modal.getAttribute("data-cm-collection-handle");
  const limit = parseInt(modal.getAttribute("data-cm-limit") || "6", 10);

  let hasLoaded = false;
  let isOpen = false;
  let lastAtcWasProductForm = false;

  // Global flag: Når true, må cart drawer IKKE åbne
  window.cmFlashDealBlockingDrawer = false;

  /* ------------------------------------------------------------
     Dawn: blokér cart drawer mens popup er aktiv
  ------------------------------------------------------------ */
  function patchCartDrawerOpen() {
    if (!window.customElements) return;

    window.customElements.whenDefined("cart-drawer").then(() => {
      const CartDrawer = window.customElements.get("cart-drawer");
      if (!CartDrawer || !CartDrawer.prototype) return;
      if (CartDrawer.prototype.__cmPatched) return;

      CartDrawer.prototype.__cmPatched = true;
      const originalOpen = CartDrawer.prototype.open;

      if (typeof originalOpen !== "function") return;

      CartDrawer.prototype.open = function () {
        if (window.cmFlashDealBlockingDrawer) return;
        return originalOpen.apply(this, arguments);
      };
    });
  }
  patchCartDrawerOpen();

  function getCartDrawerEl() {
    return document.querySelector("cart-drawer");
  }

  function closeDrawerIfOpen() {
    const drawer = getCartDrawerEl();
    if (!drawer) return;
    if (typeof drawer.close === "function") drawer.close();
    drawer.removeAttribute("open");
    drawer.classList.remove("active", "is-visible");
  }

  function openDrawer() {
    const drawer = getCartDrawerEl();
    if (!drawer) return;

    if (typeof drawer.open === "function") return drawer.open();

    const trigger =
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector('[data-cart-drawer-trigger]');
    if (trigger) trigger.click();
  }

  async function refreshCartDrawerSection() {
    const res = await fetch("/?sections=cart-drawer", { credentials: "same-origin" });
    if (!res.ok) return;

    const data = await res.json();
    const html = data["cart-drawer"];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, "text/html");
    const newDrawer = doc.querySelector("cart-drawer");
    const currentDrawer = document.querySelector("cart-drawer");

    if (newDrawer && currentDrawer) {
      currentDrawer.innerHTML = newDrawer.innerHTML;
    }
  }

  /* ------------------------------------------------------------
     iOS / Safari: HARD reset af horisontal scroll
  ------------------------------------------------------------ */
  function disableSnap() {
    if (!grid) return;
    grid.style.setProperty("scroll-snap-type", "none", "important");
  }

  function enableSnap() {
    if (!grid) return;
    grid.style.removeProperty("scroll-snap-type"); // CSS tager over igen
  }

  function hardScrollToStart() {
    if (!grid) return;

    grid.scrollLeft = 0;
    grid.scrollTo({ left: 0, top: 0, behavior: "auto" });

    // iOS: lås scrollLeft = 0 i flere frames
    let frames = 0;
    const lock = () => {
      grid.scrollLeft = 0;
      frames++;
      if (frames < 12) requestAnimationFrame(lock);
    };
    requestAnimationFrame(lock);
  }

  function waitForGridImages() {
    if (!grid) return Promise.resolve();
    const imgs = Array.from(grid.querySelectorAll("img"));
    if (!imgs.length) return Promise.resolve();

    return Promise.all(
      imgs.map((img) =>
        img.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              img.addEventListener("load", resolve, { once: true });
              img.addEventListener("error", resolve, { once: true });
            })
      )
    );
  }

  function forceResetSequence() {
    if (!grid) return;

    disableSnap();
    hardScrollToStart();

    setTimeout(hardScrollToStart, 60);
    setTimeout(hardScrollToStart, 180);

    // Snap TIL igen når layout er stabilt
    setTimeout(() => {
      enableSnap();
      hardScrollToStart();
    }, 320);
  }

  /* ------------------------------------------------------------
     Modal open / close
  ------------------------------------------------------------ */
  function openModal() {
    if (isOpen) return;
    isOpen = true;

    window.cmFlashDealBlockingDrawer = true;
    closeDrawerIfOpen();

    if (typeof modal.showModal === "function") modal.showModal();
    grid.scrollTo({ left: 0, behavior: "instant" });
    modal.setAttribute("open", "");
    document.documentElement.classList.add("overflow-hidden");

    const firstClose = modal.querySelector("[data-cm-close]");
    if (firstClose?.focus) {
      try {
        firstClose.focus({ preventScroll: true });
      } catch {
        firstClose.focus();
      }
    }

    forceResetSequence();
  }

  function closeModal() {
    if (!isOpen) return;
    isOpen = false;

    if (typeof modal.close === "function") modal.close();
    modal.removeAttribute("open");
    document.documentElement.classList.remove("overflow-hidden");

    forceResetSequence();
  }

  closeEls.forEach((el) =>
    el.addEventListener("click", async () => {
      closeModal();
      window.cmFlashDealBlockingDrawer = false;
      await refreshCartDrawerSection();
      openDrawer();
    })
  );

  if (goCartBtn) {
    goCartBtn.addEventListener("click", async () => {
      closeModal();
      window.cmFlashDealBlockingDrawer = false;
      await refreshCartDrawerSection();
      openDrawer();
    });
  }

  /* ------------------------------------------------------------
     Data & rendering
  ------------------------------------------------------------ */
  function formatMoneyDKK(v) {
    const n = Number(String(v).replace(",", "."));
    if (Number.isNaN(n)) return "";
    return n.toFixed(2).replace(".", ",") + " kr.";
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  async function fetchCollectionProducts() {
    if (!collectionHandle) return [];
    const res = await fetch(
      `/collections/${collectionHandle}/products.json?limit=${limit}`,
      { credentials: "same-origin" }
    );
    if (!res.ok) return [];
    const data = await res.json();
    return data.products || [];
  }

  function renderProducts(products) {
    if (!products.length) {
      grid.innerHTML = "<p>Ingen produkter.</p>";
      forceResetSequence();
      return;
    }

    grid.innerHTML = products
      .map((p) => {
        const v = p.variants?.[0];
        if (!v) return "";

        const img =
          p.featured_image?.src ||
          p.images?.[0]?.src ||
          "";

        return `
          <div class="cm-flashdeal-card">
            <div class="cm-flashdeal-card__media">
              <img src="${img}" alt="${escapeHtml(p.title)}" loading="lazy">
            </div>
            <div class="cm-flashdeal-card__info">
              <p class="cm-flashdeal-card__title">${escapeHtml(p.title)}</p>
              <div class="cm-flashdeal-card__price">
                ${formatMoneyDKK(v.price)}
                ${
                  v.compare_at_price
                    ? `<span style="text-decoration:line-through;opacity:.6;margin-left:8px;">${formatMoneyDKK(
                        v.compare_at_price
                      )}</span>`
                    : ""
                }
              </div>
              <button class="cm-flashdeal-card__btn" data-cm-add data-variant-id="${v.id}">
                Tilføj
              </button>
            </div>
          </div>
        `;
      })
      .join("");

    forceResetSequence();

    waitForGridImages().then(() => {
      forceResetSequence();
    });

    grid.querySelectorAll("[data-cm-add]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        btn.disabled = true;
        btn.textContent = "Tilføjer…";

        try {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1 }),
          });
          btn.textContent = "Tilføjet ✓";
        } catch {
          btn.disabled = false;
          btn.textContent = "Prøv igen";
        }
      });
    });
  }

  async function ensureLoaded() {
    if (hasLoaded) return;
    hasLoaded = true;
    const products = await fetchCollectionProducts();
    renderProducts(products);
  }

  /* ------------------------------------------------------------
     Hook ATC → popup
  ------------------------------------------------------------ */
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action?.includes("/cart/add")) return;
    lastAtcWasProductForm = true;
    setTimeout(() => (lastAtcWasProductForm = false), 2000);
  });

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await originalFetch.apply(this, args);
    try {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
      if (url.includes("/cart/add") && res.ok && lastAtcWasProductForm) {
        await ensureLoaded();
        openModal();
      }
    } catch {}
    return res;
  };
})();
